const modalThemeTextStyle = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 16,
  fontWeight: 400,
};

export default modalThemeTextStyle;